export default "__VITE_ASSET__DTbS7K$5__"